import React, { useEffect, useRef, useState } from 'react';
import { HiOutlinePlus } from 'react-icons/hi';
import { EmailBlockKind } from '../../../../../../../types/communication';
import { EMAIL_BLOCK_HINTS, EMAIL_BLOCK_LABELS } from '../../../../../../../utils/emailHtml';
import { BLOCK_ICONS, BLOCK_ORDER } from './blockIcons';

interface AddBlockMenuProps {
    onAdd: (kind: EmailBlockKind) => void;
    variant?: 'inline' | 'footer';
}

const AddBlockMenu: React.FC<AddBlockMenuProps> = ({ onAdd, variant = 'inline' }) => {
    const [open, setOpen] = useState(false);
    const rootRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!open) return undefined;
        const close = (event: MouseEvent) => {
            if (rootRef.current && !rootRef.current.contains(event.target as Node)) setOpen(false);
        };
        document.addEventListener('mousedown', close);
        return () => document.removeEventListener('mousedown', close);
    }, [open]);

    return (
        <div ref={rootRef} className={`relative ${variant === 'inline' ? 'h-4 group/add' : ''}`}>
            {variant === 'inline' ? (
                <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 flex items-center opacity-0 group-hover/add:opacity-100 focus-within:opacity-100 transition-opacity">
                    <div className="flex-1 border-t border-dashed border-teal-300" />
                    <button
                        type="button"
                        onClick={() => setOpen((o) => !o)}
                        className="mx-2 w-6 h-6 rounded-full bg-teal-500 text-white flex items-center justify-center shadow"
                        aria-label="Inserir bloco aqui"
                    >
                        <HiOutlinePlus size={14} />
                    </button>
                    <div className="flex-1 border-t border-dashed border-teal-300" />
                </div>
            ) : (
                <button
                    type="button"
                    onClick={() => setOpen((o) => !o)}
                    className="w-full flex items-center justify-center gap-2 rounded-xl border-2 border-dashed border-gray-300 dark:border-slate-600 py-3 text-sm text-gray-500 hover:border-teal-400 hover:text-teal-700 dark:hover:text-teal-300"
                >
                    <HiOutlinePlus size={16} /> Adicionar bloco
                </button>
            )}
            {open && (
                <div className="absolute z-30 left-1/2 -translate-x-1/2 mt-2 w-72 max-w-[90vw] flex flex-col gap-1 p-2 rounded-xl border border-gray-200 dark:border-slate-600 bg-white dark:bg-slate-800 shadow-xl">
                    {BLOCK_ORDER.map((kind) => (
                        <button
                            key={kind}
                            type="button"
                            onClick={() => {
                                onAdd(kind);
                                setOpen(false);
                            }}
                            className="flex items-start gap-2 rounded-lg px-2.5 py-2 text-left hover:bg-slate-50 dark:hover:bg-slate-700"
                        >
                            <span className="mt-0.5 text-teal-600 dark:text-teal-300">{BLOCK_ICONS[kind]}</span>
                            <span>
                                <span className="block text-sm text-gray-800 dark:text-gray-100">{EMAIL_BLOCK_LABELS[kind]}</span>
                                <span className="block text-[11px] text-gray-400">{EMAIL_BLOCK_HINTS[kind]}</span>
                            </span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default AddBlockMenu;
